import styled from 'styled-components';

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
	width: 510px;

	@media only screen and (min-device-width: 768px) and (max-device-width: 768px) {
		width: 100%;
	}

	@media only screen and (min-device-width: 820px) and (max-device-width: 820px) {
		width: 100%;
	}
`;

export const Content = styled.div`
	padding: 16px 20px;
`;

export const Header = styled.div`
	margin-bottom: 25px;
`;

export const PersonName = styled.div``;
